export default __webpack_public_path__ + "static/media/skill_img.a43dccb4.jpg";